
const authentication = require('../../../react-azure-adb2c2').default;
export const calendar = (values: any) => {
    // const url = process.env.REACT_APP_API_CRM_URL + `/api/v1/rent/contract/follows/list`;
    // const url = `http://localhost:5000/v1/rent/customer/contacts/calendar`;
    // const url = process.env.REACT_APP_API_CRM_URL + `/v1/rent/customer/contacts/calendar`
    let url = process.env.REACT_APP_API_PM_URL + `/v1/pm/cleaning/schedule`;
    // const url = 'http://localhost:5000/v1/pm/cleaning/schedule'
    // alert(url)
    const token = authentication.getAccessToken();
    //const search = values ? values : {};
    // alert(JSON.stringify(values))

    return fetch(url, {
        method: 'post',
        body: JSON.stringify(values),
        headers: { 'Authorization': 'Bearer ' + token, 'Content-type': 'application/json; charset=UTF-8' }
    })
        .then(res => res.json())
        .then(payload => ({ payload }))
        .catch(error => ({ error }));

}

